import {Skeleton, SkeletonProps} from "@chakra-ui/react";

export const LightSkeleton = (props:SkeletonProps) => {
  return <Skeleton {...props} startColor="gray.50" endColor="gray.200" />;
}